import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ManageBuyerDetailsService {

  constructor(private _http: HttpClient) { }

  getdetails(data) {
      return this._http.post(environment.api_url+'admin/user/details',data);
  }

  changestatus(data) {
    return this._http.post(environment.api_url+'admin/user/approve',data);
  }

  updatebank(data) {
    return this._http.post(environment.api_url+'admin/user/updatebankdetails',data);
  }

  updateprofile(data) {
      return this._http.post(environment.api_url+'admin/user/updateemail',data);
  }

    updateregisteredaddress(data) {
        return this._http.post(environment.api_url+'admin/updateuserregaddress',data);
    }

}
